import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PositiveListService from "src/modules/data-protection/apis/PositiveListService";
import {
    POSITIVE_LIST_QUERY_KEY,
    buildPositiveListQueryParams,
    normalizePositiveList,
} from "../helpers/measureList";

const usePositiveList = ({ softwareId, filters, t } = {}) => {
    return useQuery({
        queryKey: [POSITIVE_LIST_QUERY_KEY, softwareId, filters],
        queryFn: async () => {
            const service = PositiveListService.getInstance();
            const payload = await service.listMeasures(
                softwareId,
                buildPositiveListQueryParams(filters)
            );

            return normalizePositiveList(payload);
        },
        enabled: Boolean(softwareId),
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t
                    ? t("An error occurred while fetching implemented measures.")
                    : "An error occurred while fetching implemented measures.",
                {
                    type: "error",
                }
            );
        },
    });
};

export default usePositiveList;
